//
// user-settings-routing.js
//
// Copyright (c) 2016 by Curalate, Inc.
//

/* jshint devel: true, jquery: true */
/* global angular: false, window: false, _: false, moment: false */

((() => {
    angular.module('curalate').config(['$routeProvider', '$locationProvider',
        ($routeProvider, $locationProvider) => {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false,
            }).hashPrefix('!');
            $routeProvider.
                when('/v1/user-settings/', {
                    templateUrl: '/app/components/user-settings/user-settings.html',
                    controller: 'UserSettingsController',
                    reloadOnSearch: false,
                }).
                otherwise({
                    redirectTo: '/v1/user-settings/',
                });
        },
    ]);
}))();
